// src/pages/ManageSubscription.js
import React, { useEffect,useState } from "react";
import SubscriptionHeader from "../components/managesubs/SubscriptionHeader";
import SubscriptionInfo from "../components/managesubs/SubscriptionInfo";
import ManagePricingSection from "../components/managesubs/ManagePricingSection"; // Updated import
import { useAuth } from "../context/Authcontext";
import {  getPlanName} from "../enums/prices";
import {getSubscription,getPriceData} from '../api/stripe/stripe'
import { useNavigate } from 'react-router-dom';

const ManageSubscription = () => {
  const [plan,setPlan] = useState("No active Plan");
  const [status,setStatus] = useState(false);
  const [daysLeft,setDayLeft] = useState(0);
  const [maxCredits,setMaxCredits] = useState(0);
  const [barValue,setBarValue] = useState(0);
  const [availableCredits , setAvailableCredits]=useState(0);
  const { user} = useAuth();
  const [fetched, setFetched] = useState(false);

  const navigate = useNavigate();

  const handleSubscription = async () => {
    try {
      const subscriptionDetails = await getSubscription();
      if (subscriptionDetails?.status !== 404) {
        console.log(subscriptionDetails);
        const priceData = await getPriceData({ priceId: subscriptionDetails.priceId });
        setMaxCredits(priceData.leads);
  
        const periodStart = new Date();
        const periodEnd = new Date(user.subscriptioupdatedAt);
        periodEnd.setDate(periodEnd.getDate() + 30);
        const daysLeft = Math.ceil((periodEnd.getTime() - periodStart.getTime()) / (1000 * 60 * 60 * 24));
        setDayLeft(daysLeft);
  
        setAvailableCredits(user.Availableleads);
        setStatus(subscriptionDetails.status);
  
        const bar = Math.ceil((user.Availableleads * 100) / priceData.leads);
        setBarValue(bar);
  
        setPlan(getPlanName(subscriptionDetails.planType));
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    handleSubscription();
  }, []);
  return (
    <div className="min-h-screen bg-gray-100">
      <SubscriptionHeader />
      <main className="pt-20">
        <SubscriptionInfo
          plan={plan}
          status={status}
          daysLeft={daysLeft}
          maxCredits={maxCredits}
          barValue={barValue}
          availableCredits={availableCredits}
        />
        <ManagePricingSection currentPlan={plan} /> {/* Updated component */}
      </main>
    </div>
  );
};

export default ManageSubscription;